<template>
  <v-app>
    <sidebar v-model="visible" />
    <headbar v-model="visible" />
    <v-main>
      <v-container fluid class="h-100">
        <slot />
      </v-container>
    </v-main>
  </v-app>
</template>

<script lang="ts" setup>
import { useDisplay } from 'vuetify'

const visible = ref(true)
const { mobile } = useDisplay()
onMounted(() => {
  visible.value = !mobile.value
})
</script>
